import React, { useState } from 'react';
import './SearchBarNav.css';

const SearchBarNav = ({ onSearch }) => {
  const [query, setQuery] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    if (query.trim()) {
      onSearch(query.trim());
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      handleSubmit(e);
    }
  };

  return (
    <div className="navSearch-bar">
      <form onSubmit={handleSubmit} className="navSearch-form">
        <div className="navSearch-input-wrapper">
          <input
            type="text"
            placeholder="Search articles and tools..."
            value={query}
            onChange={(e) => setQuery(e.target.value)}
            onKeyPress={handleKeyPress}
            className="navSearch-input"
          />
          <button type="submit" className="navSearch-btn">
            <svg 
              width="15" 
              height="15" 
              viewBox="0 0 24 24" 
              fill="none" 
              stroke="currentColor" 
              strokeWidth="2" 
              strokeLinecap="round" 
              strokeLinejoin="round"
            >
              <circle cx="11" cy="11" r="8"></circle>
              <path d="m21 21-4.35-4.35"></path>
            </svg>
          </button>
        </div>
      </form>
    </div>
  );
};

export default SearchBarNav; 